import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Pagination } from "antd";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { API } from "../../Config/API";
import { GET } from "../../utils/apiCalls";
import Header from "../../component/header";
import Footer from "../../component/footer/footer";
// import StickyAdds from "../../component/adds/stickyAdds";
import nophoto from "../../asset/images/null-image.png";
import { s3FallbackUrl } from "../../utils/mediaFallback";
import "./styles.scss";

function VidyaprabhaathamAll() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  // Get initial values from URL params or use defaults
  const initialPage = parseInt(searchParams.get("page") || "1");
  const initialPageSize = parseInt(searchParams.get("pageSize") || "12");

  const [pageSize, setPageSize] = useState(initialPageSize);
  const [page, setPage] = useState(initialPage);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Set initial URL params if they don't exist
  useEffect(() => {
    if (!searchParams.get("page") || !searchParams.get("pageSize")) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", page.toString());
      newParams.set("pageSize", pageSize.toString());
      setSearchParams(newParams, { replace: true });
    }
    setIsInitialLoad(false);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadData(page, pageSize);
  }, [page, pageSize]);

  // Update URL when page or pageSize changes (but not on initial load)
  useEffect(() => {
    if (!isInitialLoad) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", page.toString());
      newParams.set("pageSize", pageSize.toString());
      setSearchParams(newParams, { replace: true });
    }
  }, [page, pageSize, isInitialLoad]);

  const loadData = async (currentPage: number, limit: number) => {
    try {
      setLoading(true);
      const start = (currentPage - 1) * limit;
      const url = `${API.VIDYA_PRABHAATHAM}?populate=*&sort[0]=createdAt:desc&sort[1]=id:desc&pagination[start]=${start}&pagination[limit]=${limit}&filters[is_deleted][$eq]=false`;
      const response: any = await GET(url, {});
      setData(response?.data || []);
      setTotal(response?.meta?.pagination?.total || 0);
    } catch (err) {
      console.error(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClickVidya = (item: any) => {
    let result = item?.attributes?.permalink.replaceAll(" ", "-");
    window.open(
      `${API.PRABHAATHAM_URL}?id=${item?.id}&link=${result}`,
      "_blank"
    );
  };

  const preventImageDrag = (e: React.DragEvent<HTMLImageElement>) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  return (
    <div>
      <Header />
      <div className="Homescreen-box">
        <Container>
          <br />
          <div className="Head-section-m">
            <div className="Head-n">
              <span onClick={() => navigate(-1)} className="all-back-btn">
                <FaArrowLeft color={"rgb(5, 118, 183)"} />{" "}
              </span>
              &nbsp;Vidya Prabhaatham
            </div>
          </div>

          {loading ? (
            <div className="Homescreen-loading">Loading . . .</div>
          ) : data.length ? (
            <>
              <Row>
                {data.map((item: any) => {
                  const imageURL =
                    item?.attributes?.image1 || item?.attributes?.profile;

                  return (
                    <Col
                      sm={3}
                      key={item?.id}
                      onClick={() => handleClickVidya(item)}
                    >
                      <div
                        className="Homescreen-item"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="Homescreen-itemBox">
                          <img
                            src={imageURL || nophoto}
                            className="Homescreen-itemImg2"
                            alt="No Image"
                            draggable={false}
                            onDragStart={preventImageDrag}
                            onContextMenu={(e) => e.preventDefault()}
                            onError={(e) => {
                              const img = e.currentTarget;
                              if (!img.dataset.s3tried) {
                                const fb = s3FallbackUrl(
                                  img.currentSrc || img.src
                                );
                                if (fb && fb !== img.src) {
                                  img.dataset.s3tried = "1";
                                  img.src = fb; // try S3 backup first
                                  return;
                                }
                              }
                              img.src = nophoto; // final placeholder fallback
                            }}
                          />
                        </div>
                        <div className="Homescreen-itemBox2">
                          <div>{"Vidya Prabhaatham"}</div>
                          <div>
                            {moment(item?.attributes?.createdAt)
                              .utcOffset(330)
                              .format("DD-MMM-YYYY")}
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>

              {/* Pagination */}
              <div
                className="pagingBox"
                style={{ textAlign: "center", marginTop: 20 }}
              >
                <Pagination
                  current={page}
                  total={total}
                  pageSize={pageSize}
                  showSizeChanger
                  pageSizeOptions={["12", "24", "48", "96"]}
                  onChange={(p, size) => {
                    setPage(p);
                    if (size) setPageSize(size);
                  }}
                  onShowSizeChange={(p, size) => {
                    setPage(1); // Reset to page 1 when page size changes
                    setPageSize(size);
                  }}
                />
              </div>
            </>
          ) : (
            <div className="Homescreen-loading">No data found</div>
          )}
          <br />
        </Container>
        {/* <StickyAdds /> */}
      </div>
      <Footer />
    </div>
  );
}

export default VidyaprabhaathamAll;
